import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const NewsTicker = ({ articles }) => {
  if (!articles || articles.length === 0) return null;

  const tickerItems = [...articles, ...articles];

  return (
    <div
      className="bg-stone-900 text-white overflow-hidden border-b border-stone-800"
      data-testid="news-ticker"
    >
      <div className="max-w-screen-2xl mx-auto flex items-center">
        {/* Label */}
        <div className="flex-shrink-0 bg-[#1B4F72] px-4 py-2.5 flex items-center gap-2 z-10">
          <Zap className="w-3.5 h-3.5" />
          <span className="font-mono text-[10px] uppercase tracking-widest font-bold">
            Son Dakika
          </span>
        </div>

        {/* Scrolling Ticker */}
        <div className="overflow-hidden flex-1">
          <div className="ticker-animate flex items-center whitespace-nowrap py-2.5">
            {tickerItems.map((article, idx) => (
              <Link
                key={`${article.id}-${idx}`}
                to={`/haber/${article.slug || article.id}`}
                className="inline-flex items-center mx-8 hover:text-[#D4AF37] transition-colors"
              >
                <span className="w-1.5 h-1.5 bg-[#1B4F72] rounded-full mr-3 flex-shrink-0" />
                <span className="text-sm font-light tracking-wide">
                  {article.title}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
